import Layout from "@/components/layout/Layout";
import { SEO } from "@/components/SEO";

const models = [
  {
    name: "Claude",
    company: "Anthropic",
    versions: "Opus 4.6, Sonnet 4.6, Opus 4.5, Haiku 4.5",
    description: "משפחת מודלי שפה מתקדמת, נחשבת לאחת הבטוחות והמדויקות בתעשייה. Opus 4.6 (פברואר 2026) הוא המודל החכם ביותר, מיועד לניתוח פיננסי, קידוד מורכב ומשימות ארוכות טווח. Sonnet 4.6 (פברואר 2026) הוא מודל ברירת המחדל החדש — מהיר, חסכוני, ומגיע לרמת ביצועים שבעבר דרשה מודל Opus. תומך בחלון הקשר של מיליון טוקנים.",
    advantages: "חלון הקשר של עד מיליון טוקנים, סגנון כתיבה אנושי ומדויק, רמת בטיחות מובילה בתעשייה, יכולות שימוש במחשב (Computer Use), Claude Code לפיתוח אגנטי, ו-Claude Cowork למשתמשים לא טכניים.",
    target: "מפתחים (Claude Code), אנשי עסקים ומחקר (Opus), כותבי תוכן ושימוש יומיומי (Sonnet), אפליקציות מהירות וחסכוניות (Haiku).",
    url: "https://claude.ai"
  },
  {
    name: "GPT-5.2 / 5.3-Codex",
    company: "OpenAI",
    versions: "Instant, Thinking, Codex",
    description: "סדרת המודלים החדשה של OpenAI. מודל 5.2 מציע מצבי עבודה ייעודיים (ביצועים מהירים מול חשיבה עמוקה). מודל 5.3-Codex הוא המודל האגנטי המתקדם ביותר. מודל GPT-4o הוצא משירות ב-13.2.2026.",
    advantages: "יכולות אגנטיות מלאות, ביצוע משימות מורכבות ללא פיקוח, שליטה מוחלטת בכתיבת קוד.",
    target: "משתמשים עסקיים, מפתחי אוטומיזציות ויוצרי סוכני AI.",
    url: "https://chatgpt.com"
  },
  {
    name: "Gemini 3 / 3.1 Pro",
    company: "Google DeepMind",
    versions: "Pro, Flash, Deep Think",
    description: "שוחרר ב-19.2.2026. מודל מולטימודלי המובנה בתוך מוצרי גוגל, עם יכולת עיבוד של כמויות מידע עצומות. גרסת Deep Think מציעה יכולות הסקה מתמטיות ומדעיות פורצות דרך.",
    advantages: "אינטגרציה מושלמת עם Google Workspace, חשיבה לוגית עמוקה, עיבוד וידאו ואודיו בזמן אמת.",
    target: "משתמשים גוגל, ארגונים גדולים ומדעני נתונים.",
    url: "https://gemini.google.com"
  },
  {
    name: "Llama 4",
    company: "Meta",
    versions: "Scout, Maverick",
    description: "הדור הרביעי של מודל הקוד הפתוח של Meta (שוחרר אפריל 2025). גרסת Scout מיועדת ליעילות מקסימלית וגרסת Maverick לפתרון בעיות יצירתיות. מודל Behemoth הגדול ביותר נמצא עדיין בשלבי אימון.",
    advantages: "גמישות מלאה למפתחים, ניתן להרצה מקומית, רמת ביצועים של מודלים סגורים ללא עלות רישוי.",
    target: "מפתחי קוד פתוח, סטארט-אפים וחברות טכנולוגיה.",
    url: "https://llama.meta.com"
  },
  {
    name: "Mistral Large 3",
    company: "Mistral AI",
    versions: "Ministral 3, Devstral 2, Magistral",
    description: "המודל האירופאי המוביל בטכנולוגיית MoE (675B פרמטרים). מציע יעילות חישובית יוצאת דופן עם 41B פרמטרים פעילים בלבד בכל רגע. גרסאות Ministral מותאמות למכשירים ניידים.",
    advantages: "דיוק לוגי גבוה, פרטיות נתונים מחמירה, יכולות קידוד מצוינות במודלים קטנים.",
    target: "מפתחים אירופאיים וארגונים המחפשים יעילות ואבטחה.",
    url: "https://mistral.ai"
  }
];

const AIModels = () => {
  return (
    <Layout>
      <SEO 
        title="מדריך מודלי AI מומלצים" 
        description="סקירה אובייקטיבית ועדכנית של מודלי השפה (LLM) המובילים בעולם. Claude, ChatGPT, Gemini, Llama ועוד." 
      />
      <div className="bg-white min-h-screen pt-32 pb-20">
        <div className="container mx-auto px-6 max-w-4xl">
          <header className="mb-20 text-right">
            <p className="text-xs font-bold tracking-widest text-slate-400 uppercase mb-3">מדריך מקצועי</p>
            <h1 className="text-4xl font-black text-slate-900 tracking-tight mb-4">מודלי AI</h1>
            <p className="text-lg text-slate-500 leading-relaxed max-w-2xl font-light">
              סקירה אובייקטיבית ועדכנית של מודלי השפה המובילים בעולם. המידע נכון לפברואר 2026.
            </p>
          </header>

          <div className="space-y-16">
            {models.map((model, idx) => (
              <article key={idx} className="group">
                <div className="border-b border-slate-100 pb-12 transition-colors">
                  <div className="flex flex-col md:flex-row md:items-baseline justify-between mb-8 gap-2">
                    <div className="space-y-1">
                      <h2 className="text-2xl font-bold text-slate-900">{model.name}</h2>
                      <p className="text-sm font-medium text-slate-400">{model.company}</p>
                    </div>
                    <span className="text-xs font-mono text-slate-400 bg-slate-50 px-3 py-1 rounded-full">
                      {model.versions}
                    </span>
                  </div>

                  <div className="grid md:grid-cols-3 gap-8 md:gap-12">
                    <div className="md:col-span-2 space-y-6 text-right">
                      <p className="text-slate-600 leading-relaxed text-base font-normal">
                        {model.description}
                      </p>
                      <div className="space-y-2">
                        <p className="text-xs font-bold text-slate-900 uppercase tracking-wide">יתרונות מרכזיים</p>
                        <p className="text-sm text-slate-500 leading-relaxed">
                          {model.advantages}
                        </p>
                      </div>
                    </div>
                    
                    <div className="space-y-6">
                      <div className="space-y-2">
                        <p className="text-xs font-bold text-slate-900 uppercase tracking-wide">למי מתאים</p>
                        <p className="text-sm text-slate-500">{model.target}</p>
                      </div>
                      <a 
                        href={model.url} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="inline-block text-xs font-bold text-blue-600 hover:text-blue-800 transition-colors uppercase tracking-widest border-b border-blue-600/20 pb-1"
                      >
                        ביקור באתר המודל
                      </a>
                    </div>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AIModels;